<!-- App Shell Container - Mobile Native Style -->
<div class="app-shell-container" 
     [class.dark-theme]="(currentTheme$ | async)?.isDark"
     [class.ih-mobile-page]="isIHMobilePage">
  
  <!-- IH* Mobile Pages (EmptyLayout) - No Header/Navigation -->
  <div *ngIf="isIHMobilePage" class="ih-mobile-container">

    <!-- IHUB soul layer: bespoke Lao "paper-roundel" product marks (v2 handoff).
         Hidden sprite rendered once in the persistent shell; cards reference a
         symbol via <use [attr.href]="getProductMark(productId)">. -->
    <svg aria-hidden="true" focusable="false" style="position:absolute;width:0;height:0;overflow:hidden">
      <defs>
        <!-- savings (SV): rice stalk -->
        <symbol id="mark-rice" viewBox="0 0 56 56">
          <circle cx="28" cy="28" r="27" fill="#fbf3df" stroke="#c9a14a" stroke-width="1.2"/>
          <g stroke="#7a1218" stroke-width="2" fill="none" stroke-linecap="round"><path d="M28 44c0-12 0-22-1-30"/></g>
          <g stroke="#5a7a3e" stroke-width="2" fill="none" stroke-linecap="round">
            <path d="M27 30c-6-2-10-7-12-14 7 1 11 6 13 11"/>
            <path d="M28 34c6-3 10-8 12-16-7 1-11 7-13 14"/></g>
          <g fill="#c9a14a">
            <ellipse cx="28" cy="15" rx="2.4" ry="5"/>
            <ellipse cx="22" cy="21" rx="2" ry="4" transform="rotate(-22 22 21)"/>
            <ellipse cx="34" cy="21" rx="2" ry="4" transform="rotate(22 34 21)"/></g>
        </symbol>
        <!-- whole life (WL): sheltering roof over heart -->
        <symbol id="mark-shelter" viewBox="0 0 56 56">
          <circle cx="28" cy="28" r="27" fill="#fbf3df" stroke="#c9a14a" stroke-width="1.2"/>
          <path d="M12 30L28 16l16 14" fill="none" stroke="#7a1218" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M28 42c-5-4-9-7-9-12 0-3 2-5 5-5 2 0 3 1 4 3 1-2 2-3 4-3 3 0 5 2 5 5 0 5-4 8-9 12z" fill="#b5202a"/>
        </symbol>
        <!-- loan / credit (LC): house under shelter -->
        <symbol id="mark-house" viewBox="0 0 56 56">
          <circle cx="28" cy="28" r="27" fill="#fbf3df" stroke="#c9a14a" stroke-width="1.2"/>
          <path d="M14 27L28 16l14 11" fill="none" stroke="#c9a14a" stroke-width="2.2" stroke-linecap="round"/>
          <path d="M18 28v12h20V28L28 20z" fill="none" stroke="#7a1218" stroke-width="2.2" stroke-linejoin="round"/>
          <path d="M25 40v-7h6v7" fill="none" stroke="#b5202a" stroke-width="2"/>
        </symbol>
        <!-- short term (ST): lightning leaf -->
        <symbol id="mark-bolt" viewBox="0 0 56 56">
          <circle cx="28" cy="28" r="27" fill="#fbf3df" stroke="#c9a14a" stroke-width="1.2"/>
          <path d="M31 14l-12 18h8l-3 12 12-18h-8z" fill="#b5202a" stroke="#7a1218" stroke-width="1.4" stroke-linejoin="round"/>
        </symbol>
        <!-- retirement (RT): sun over hills -->
        <symbol id="mark-sun" viewBox="0 0 56 56">
          <circle cx="28" cy="28" r="27" fill="#fbf3df" stroke="#c9a14a" stroke-width="1.2"/>
          <circle cx="28" cy="26" r="7" fill="none" stroke="#b5202a" stroke-width="2.2"/>
          <g stroke="#c9a14a" stroke-width="2" stroke-linecap="round"><path d="M28 13v-3M40 26h3M13 26h3M37 17l2-2M17 17l-2-2"/></g>
          <path d="M12 40c5-6 10-6 16 0 6-6 11-6 16 0" fill="none" stroke="#5a7a3e" stroke-width="2.4" stroke-linecap="round"/>
        </symbol>
      </defs>
    </svg>

    <router-outlet></router-outlet>

    <!-- IHUB redesign bottom tab bar (main tab roots only; flag-gated) -->
    <app-ih-tabbar *ngIf="showTabBar"></app-ih-tabbar>
  </div>

  <!-- Standard App Layout with Header/Navigation -->
  <div *ngIf="!isIHMobilePage" class="app-container">
    
    <!-- Header -->
    <app-header 
      class="app-header"
      [showMenuButton]="true"
      [currentTheme]="(currentTheme$ | async)"
      (menuClick)="toggleNavigation()"
      (themeToggle)="toggleTheme()">
    </app-header>

    <!-- Main Content Wrapper -->
    <main class="app-content-wrapper" role="main">
      
      <!-- Loading Indicator -->
      <div class="app-loading-container" *ngIf="false" aria-hidden="true">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="sr-only">Loading content...</span>
      </div>

      <!-- Router Outlet for Page Content -->
      <div class="app-router-outlet">
        <router-outlet></router-outlet>
      </div>
      
    </main>
    
    <!-- Bottom Navigation Drawer (Mobile) -->
    <mat-drawer-container class="drawer-container" [hasBackdrop]="true">
      <mat-drawer 
        #drawer 
        mode="over" 
        position="end"
        class="mobile-drawer">
        
        <div class="drawer-content">
          <div class="drawer-header">
            <h3>Menu</h3>
            <button mat-icon-button (click)="drawer.close()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          
          <app-navigation 
            (navigationClick)="drawer.close()">
          </app-navigation>
        </div>
        
      </mat-drawer>
    </mat-drawer-container>
    
  </div>
  
  <!-- Accessibility Skip Links -->
  <div class="skip-links">
    <a class="skip-link" href="#main-content" tabindex="1">
      Skip to main content
    </a>
  </div>

  <!-- Screen Reader Announcements -->
  <div aria-live="polite" aria-atomic="true" class="sr-only">
    <div *ngIf="(currentTheme$ | async)?.isDark">Dark theme activated</div>
    <div *ngIf="!(currentTheme$ | async)?.isDark">Light theme activated</div>
  </div>

</div>